<!--
 검색 가능한 single select
------------------------------------

-->
<template>
    <div :class="classObject" :style="[defaultCssVariables, cssVariables]" class="uk-flex">
        <multiselect
            class="uk-width-expand"
            :class="multiselectClass"

            ref="multiselect"
            :value="multiselectValue"
            @input="updateValue"
            :options="options"
            label="text"

            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            :placeholder="placeholder"

            @select="e => $emit('change', e)"
            @open="openListener"
        >
            <!-- 현재 선택값 표현 -->
            <template
                slot="singleLabel"
                slot-scope="{ option }"
            >
                <slot name="singleLabel" :option="option">
                    {{ option.text }}
                </slot>
            </template>

            <!-- 검색결과없음 표현 -->
            <template slot="noResult">
                <slot name="noResult">
                    Not found element
                </slot>
            </template>

            <!-- 옵션목록 > 옵션한개 표현 -->
            <template slot="option" slot-scope="{ option }">
                <slot name="option" :option="option">
                    {{ option.text }}
                </slot>
            </template>

        </multiselect>

        <button type="button" class="btn-style" @click="clear">초기화</button>

        <!-- 히든변수 -->
        <input
            type="hidden"
            :name="name"
            :value="value"

            v-if="withHiddenInput"
        />
    </div>
</template>

<script>
    import InputBase from './base.vue';
    import Multiselect from 'vue-multiselect'

    export default {
        extends: InputBase,
        props: {
            /**
             * 컴포넌트 내에 히든변수 작성
             */
            withHiddenInput: {
                type: Boolean,
                default: false,
            },

            /**
             * multiselect 컴포넌트에 전달될 클래스명
             */
            multiselectClass: {
                type: String,
                default: null,
            },
        },
        components: {
            Multiselect
        },
        computed: {
            /**
             * 멀티셀렉트 컴포넌트에 전달할 value
             *  - 현재 선택중인 object를 찾아서 반환한다
             * @return object
             */
            multiselectValue() {
                return _.find(this.options, (option) => {
                    return this.value == option.val;
                });

            },

        },
        methods: {
            /**
             * input 의 값이 변경되었음을 알리는 이벤트 발생
             *  - 리스너에 변경된 값을 인자로 전달
             * @param event vue 이벤트 객체
             * */
            updateValue: function (event) {
                // vue-multiselect 에서 이벤트가 발생한 경우에는 인자값으로 선택값이 바로 옴.
                let value = null;
                if (event) {
                    value = event.val;
                }
                this.$emit('update:value', value);
            },

            /**
             * 드롭다운 오픈 이벤트
             */
            openListener() {
                //const dropdown = this.$refs.multiselect.$el.querySelector('.multiselect__content');
                const dropdown_wrap = this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper');
                const selected_option = this.$refs.multiselect.$el.querySelector('.multiselect__option--selected');
                //console.log(dropdown.scrollTop);

                if (dropdown_wrap && selected_option) {
                    setTimeout(() => {
                        // 현재 선택된 옵션으로 스크롤
                        dropdown_wrap.scrollTop = selected_option.offsetTop;
                  //      selected_option.scrollIntoView();
                    }, 500);

                }

            },


            /**
             * 선택값 초기화
             */
            clear() {
                this.$emit('update:value', null);
            },
        }
    }
</script>



<style lang="scss" scoped>
.btn-style {
    font-size: 0.875rem;

    border: 1px solid #ccc;
    outline: 0;
    cursor: pointer;
    color: #666;
    background-color: rgb(255, 255, 255);

    border-radius: 4px;
    padding: 4px 8px;
    display: inline-block;
    transition: background-color .24s,box-shadow .24s;

    &:hover {
        //box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 3px 9px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
    }


}
</style>